export enum MaritalStatusEnum {
  Single = "SINGLE",
  Married = "MARRIED",
  CommonLaw = "COMMON_LAW",
  Separated = "SEPARATED",
  Divorced = "DIVORCED",
  Widowed = "WIDOWED",
  Other = "OTHER"
}

export const MaritalStatusMapping: Record<string, MaritalStatusEnum> = {
  Single: MaritalStatusEnum.Single,
  Married: MaritalStatusEnum.Married,
  "Common Law": MaritalStatusEnum.CommonLaw,
  Separated: MaritalStatusEnum.Separated,
  Divorced: MaritalStatusEnum.Divorced,
  Widowed: MaritalStatusEnum.Widowed,
  Other: MaritalStatusEnum.Other
};

export enum OperatingTypeEnum {
  Corporation = "CORPORATION",
  SoleProprietorship = "SOLE_PROPRIETORSHIP",
  Partnership = "PARTNERSHIP",
  LimitedPartnership = "LIMITED_PARTNERSHIP",
  LimitedLiabilityPartnership = "LIMITED_LIABILITY_PARTNERSHIP",
  Cooperative = "COOPERATIVE",
  NonProfitOrganization = "NON_PROFIT_ORGANIZATION"
}

export const OperatingTypeMapping: Record<string, OperatingTypeEnum> = {
  Corporation: OperatingTypeEnum.Corporation,
  "Sole Proprietorship": OperatingTypeEnum.SoleProprietorship,
  Partnership: OperatingTypeEnum.Partnership,
  "Limited Partnership": OperatingTypeEnum.LimitedPartnership,
  "Limited Liability Partnership":
    OperatingTypeEnum.LimitedLiabilityPartnership,
  Cooperative: OperatingTypeEnum.Cooperative,
  "Non Profit Organization": OperatingTypeEnum.NonProfitOrganization
};

export enum IncomeTypeEnum {
  Alimony = "ALIMONY",
  ChildSupport = "CHILD_SUPPORT",
  InvestmentIncome = "INVESTMENT_INCOME",
  CanadaChildBenefit = "CANADA_CHILD_BENEFIT",
  MaternityLeave = "MATERNITY_LEAVE",
  Pension = "PENSION",
  Disability = "DISABILITY",
  Student = "STUDENT",
  Unemployment = "UNEMPLOYMENT"
}

export const IncomeTypeMapping: Record<string, IncomeTypeEnum> = {
  Alimony: IncomeTypeEnum.Alimony,
  "Child Support": IncomeTypeEnum.ChildSupport,
  "Investment Income": IncomeTypeEnum.InvestmentIncome,
  "Canada Child Benefit": IncomeTypeEnum.CanadaChildBenefit,
  "Maternity Leave": IncomeTypeEnum.MaternityLeave,
  Pension: IncomeTypeEnum.Pension,
  Disability: IncomeTypeEnum.Disability,
  Student: IncomeTypeEnum.Student,
  Unemployment: IncomeTypeEnum.Unemployment
};

export enum PropertyTypeEnum {
  Detached = "DETACHED",
  SemiDetached = "SEMI_DETACHED",
  Townhouse = "TOWNHOUSE",
  CondoTownhouse = "CONDO_TOWNHOUSE",
  Apartment = "APARTMENT",
  Condo = "CONDO"
}

export const PropertyTypeMapping: Record<string, PropertyTypeEnum> = {
  Detached: PropertyTypeEnum.Detached,
  "Semi Detached": PropertyTypeEnum.SemiDetached,
  Townhouse: PropertyTypeEnum.Townhouse,
  "Condo Townhouse": PropertyTypeEnum.CondoTownhouse,
  Apartment: PropertyTypeEnum.Apartment,
  Condo: PropertyTypeEnum.Condo
};

export enum CoApplicantIncomeSourceEnum {
  Employment = "EMPLOYMENT",
  SelfEmployment = "SELF_EMPLOYMENT",
  Investment = "INVESTMENT",
  Rental = "RENTAL",
  Pension = "PENSION",
  GovernmentBenefits = "GOVERNMENT_BENEFITS",
  CommissionBased = "COMMISSION_BASED",
  ContractWork = "CONTRACT_WORK",
  DisabilityBenefits = "DISABILITY_BENEFITS",
  Other = "OTHER"
}

export const CoApplicantIncomeSourceMapping: Record<
  string,
  CoApplicantIncomeSourceEnum
> = {
  Employment: CoApplicantIncomeSourceEnum.Employment,
  "Self Employment": CoApplicantIncomeSourceEnum.SelfEmployment,
  Investment: CoApplicantIncomeSourceEnum.Investment,
  Rental: CoApplicantIncomeSourceEnum.Rental,
  Pension: CoApplicantIncomeSourceEnum.Pension,
  "Government Benefits": CoApplicantIncomeSourceEnum.GovernmentBenefits,
  "Commission Based": CoApplicantIncomeSourceEnum.CommissionBased,
  "Contract Work": CoApplicantIncomeSourceEnum.ContractWork,
  "Disability Benefits": CoApplicantIncomeSourceEnum.DisabilityBenefits,
  Other: CoApplicantIncomeSourceEnum.Other
};

export enum RelationshipEnum {
  Child = "CHILD",
  Spouse = "SPOUSE",
  Parent = "PARENT",
  Sibling = "SIBLING",
  OtherFamilyMember = "OTHER_FAMILY_MEMBER",
  BusinessPartner = "BUSINESS_PARTNER",
  NonRelated = "NON_RELATED"
}

export const RelationshipMapping: Record<string, RelationshipEnum> = {
  Child: RelationshipEnum.Child,
  Spouse: RelationshipEnum.Spouse,
  Parent: RelationshipEnum.Parent,
  Sibling: RelationshipEnum.Sibling,
  "Other Family Member": RelationshipEnum.OtherFamilyMember,
  "Business Partner": RelationshipEnum.BusinessPartner,
  "Non Related": RelationshipEnum.NonRelated
};

export enum DownPaymentSourceEnum {
  CashSavings = "CASH_SAVINGS",
  RRSP = "RRSP",
  Gift = "GIFT",
  SaleOfProperty = "SALE_OF_PROPERTY",
  Other = "OTHER"
}

export const DownPaymentSourceMapping: Record<string, DownPaymentSourceEnum> = {
  "Bank Account": DownPaymentSourceEnum.CashSavings,
  RRSP: DownPaymentSourceEnum.RRSP,
  Gift: DownPaymentSourceEnum.Gift,
  "Sale of my Existing Property": DownPaymentSourceEnum.SaleOfProperty,
  "Other Income": DownPaymentSourceEnum.Other
};

export enum DocumentTypeEnum {
  PhotoId = "PHOTO_ID",
  T4 = "T4",
  PayStub = "PAY_STUB"
}

export enum CanadianProvinceCodeEnum {
  Alberta = "AB",
  BritishColumbia = "BC",
  Manitoba = "MB",
  NewBrunswick = "NB",
  NewfoundlandAndLabrador = "NL",
  NovaScotia = "NS",
  Ontario = "ON",
  PrinceEdwardIsland = "PE",
  Quebec = "QC",
  Saskatchewan = "SK",
  NorthwestTerritories = "NT",
  Nunavut = "NU",
  Yukon = "YT"
}

export interface AddressInterface {
  address1: string;
  address2?: string;
  city: string;
  province: CanadianProvinceCodeEnum | string;
  postalCode: string;
  country: string;
}

export interface CurrencyInterface {
  amount: number;
  currency: string;
}

export enum MortgageStatusEnum {
  Incomplete = "INCOMPLETE",
  PendingDocuments = "PENDING_DOCUMENTS",
  PendingContact = "PENDING_CONTACT",
  PendingApproval = "PENDING_APPROVAL",
  Approved = "APPROVED"
}

export const MortgageStatusMapping: Record<MortgageStatusEnum, string> = {
  [MortgageStatusEnum.Incomplete]: "Incomplete",
  [MortgageStatusEnum.PendingDocuments]: "Pending Documents",
  [MortgageStatusEnum.PendingContact]: "Pending Contact",
  [MortgageStatusEnum.PendingApproval]: "Pending Approval",
  [MortgageStatusEnum.Approved]: "Approved"
};

export interface FilesInterface {
  filename: string;
  type: DocumentTypeEnum | string;
  data: string;
  id: string;
}

enum incomeSourceEnum {
  fullTime = "FULL_TIME",
  partTime = "PART_TIME",
  selfEmployment = "SELF_EMPLOYMENT",
  rentalIncome = "RENTAL",
  otherIncome = "OTHER"
}

export interface CreditConsentInterface {
  id: string | null;
  creditScore: number | null;
  creditScoreFactors: string[] | null;
  creditInquiries:
    | {
        name: string;
        createdAt: Date;
      }[]
    | null;
  employmentHistory:
    | {
        occupation: string | null;
        name: string | null;
        description: string | null;
      }[]
    | null;
  totalMonthlyDebt: CurrencyInterface | null;
  totalDebt: CurrencyInterface | null;
  creditTradeLines:
    | {
        creditorName: string | null;
        creditorNumber: string | null;
        creditorPhone: string | null;
        accountNumber: string | null;
        accountType: string | null;
        ownershipType: string | null;
        creditLimit: CurrencyInterface | null;
        currentBalance: CurrencyInterface | null;
        monthlyPayment: CurrencyInterface | null;
        pastDueAmount: CurrencyInterface | null;
        monthsReported: number | null;
        openedOn: Date | null;
        lastActivityOn: Date | null;
        reportedOn: Date | null;
        paymentStatus: string | null;
      }[]
    | null;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
}

export interface IncomeSourceInterface {
  type: incomeSourceEnum | string;
  employerName?: string | null;
  businessName?: string | null;
  propertyType?: PropertyTypeEnum | null;
  incomeType?: IncomeTypeEnum | null;
  jobTitle?: string | null;
  startDate: Date | null;
  annualBasePay?: CurrencyInterface | null;
  annualBonuses?: CurrencyInterface | null;
  annualOvertime?: CurrencyInterface | null;
  annualCommission?: CurrencyInterface | null;
  annualIncome?: CurrencyInterface | null;
  annualAmount?: CurrencyInterface | null;
  propertyAddress?: AddressInterface | null;
  propertyValue?: CurrencyInterface | null;
  monthlyRent?: CurrencyInterface | null;
  rentalIncomeSince?: Date | null;
  dateEstablished?: Date | null;
  operatingType?: OperatingTypeEnum | null;
}

export interface MortgagePayloadInterface {
  suggestions?: string | null;
  mortgage: {
    emailAddress: string;
    status: MortgageStatusEnum | string;
    userId: string;
    coApplicants?:
      | {
          firstName: string;
          middleName?: string;
          lastName: string;
          address: AddressInterface;
          phoneNumber: string;
          emailAddress: string;
          dateOfBirth: Date;
          maritalStatus: MaritalStatusEnum | string;
          relationship: RelationshipEnum | string;
          incomeSource: CoApplicantIncomeSourceEnum | string;
          isFirstTimeHomeBuyer: boolean;
          annualBasePay: CurrencyInterface;
        }[]
      | null;
    downPaymentSources?:
      | {
          type: DownPaymentSourceEnum | string;
          amount: CurrencyInterface;
        }[]
      | null;
    files?: FilesInterface[] | null;
    createdAt?: Date;
    updatedAt?: Date;
    matchedListings: number;
    likedHomes: number;
    address?: AddressInterface | null;
    dateOfBirth?: Date | null;
    firstName?: string | null;
    pushNotification: boolean;
    isFirstTimeHomeBuyer?: boolean;
    lastName?: string | null;
    maritalStatus?: MaritalStatusEnum | string | null;
    middleName?: string;
    phoneNumber?: string;
    incomeSources?: IncomeSourceInterface[] | null;
    creditConsents?: CreditConsentInterface[] | null;

    creditScore?: number | null;
    totalDebtBuyerOnly?: CurrencyInterface | null;
    totalMonthlyDebtBuyerOnly?: CurrencyInterface | null;
    maximumAffordability?: CurrencyInterface | null;
    totalAnnualIncomeBuyerOnly?: CurrencyInterface;
    totalDownPaymentBuyerOnly?: CurrencyInterface | null;
    totalAnnualIncomeWithCoApplicants?: CurrencyInterface | null;
    totalDebtWithCoApplicants?: CurrencyInterface | null;
    totalMonthlyDebtWithCoApplicants?: CurrencyInterface | null;
    zownContribution?: CurrencyInterface | null;
    totalDownPaymentNeeded?: CurrencyInterface | null;
    totalNewDownPaymentNeeded?: CurrencyInterface | null;
    highestEligibleCreditScore?: number | null;
  };
}
